module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-sp.e9627fe7.png";